export enum WebsocketErrorEnumeration {
  WEBSOCKET_ERROR_CONNECTION = 'WEBSOCKET_ERROR_CONNECTION',
  WEBSOCKET_ERROR_DESCONNECTION = 'WEBSOCKET_ERROR_DESCONNECTION',
  WEBSOCKET_NOT_AVAILABLE = 'WEBSOCKET_NOT_AVAILABLE',
}
